export enum TreeViewSelectorValues {
  OrganizationalStructureActivities = '1',
  NavigationActivities = '2',
  Other = '3',
}

export enum ActionsSelectorValues {
  MenuAboveGrid = '1',
  ContextualMenu = '2',
}

export enum AccessibilitySelectorValues {
  CompanyTreeView = '1',
  FiltersOrSmartViews = '2',
  EndpointDetails = '3',
  CriticalIssues = '4',
  RemediationActions = '5',
  ReportsOrCsvFiles = '6',
  Other = '7',
}

export const NETWORK_V2_BETA_TYPE = 5;

export const treeViewSelectorValueToLabelMap = new Map<string, string>([
  [
    TreeViewSelectorValues.OrganizationalStructureActivities,
    'Visualize, maintain, and make changes to your organizational structure',
  ],
  [TreeViewSelectorValues.NavigationActivities, 'Navigate to a certain location'],
  [TreeViewSelectorValues.Other, 'Other. Please specify:'],
]);

export const actionsSelectorValueToLabelMap = new Map<string, string>([
  [ActionsSelectorValues.MenuAboveGrid, 'From the menu above the Network grid'],
  [ActionsSelectorValues.ContextualMenu, 'From the contextual menu (right mouse button)'],
]);

export const accessibilitySelectorValueToLabelMap = new Map<string, string>([
  [AccessibilitySelectorValues.CompanyTreeView, 'Company tree view'],
  [AccessibilitySelectorValues.FiltersOrSmartViews, 'Filters or smart views'],
  [AccessibilitySelectorValues.EndpointDetails, 'Endpoint details'],
  [AccessibilitySelectorValues.CriticalIssues, 'Critical issues'],
  [AccessibilitySelectorValues.RemediationActions, 'Remediation actions'],
  [AccessibilitySelectorValues.ReportsOrCsvFiles, 'Reports or CSV files'],
  [AccessibilitySelectorValues.Other, 'Other. Please specify:'],
]);
